import type { ScheduleReferenceData } from "@/pages/human-resources/time-management/business/reference/ScheduleReferenceData.ts";
import { createContext, type ReactNode } from "react";
import useScheduleReferenceDataLoader from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceDataLoader.ts";
import ThreeDotsOverlay from "@/shared/components/generic/loading/ThreeDotsOverlay.tsx";
import useDomainSiteOnRoute from "@/shared/routing/useDomainSiteOnRoute.ts";
import { useTranslation } from "react-i18next";
import useDefinedContextValue from "@/shared/custom-hook/useDefinedContextValue.ts";
import { ScheduleReferenceDataStateContext } from "@/pages/human-resources/time-management/schedules/reference-provider/ScheduleReferenceDataStateProvider.tsx";
import useShowError from "@/shared/custom-hook/useShowError.ts";

// eslint-disable-next-line react-refresh/only-export-components
export const ScheduleReferenceDataContext = createContext<
  ScheduleReferenceData | undefined
>(undefined);

export function ScheduleReferenceDataProvider(props: {
  children: ReactNode;
}): ReactNode {
  const { site } = useDomainSiteOnRoute();
  const refData = useScheduleReferenceDataLoader(site);
  const { loadingError } = useDefinedContextValue(
    ScheduleReferenceDataStateContext,
  );
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  useShowError(loadingError, t("errors.backend.siteData.read"));

  return refData === undefined ?
      <ThreeDotsOverlay />
    : <ScheduleReferenceDataContext.Provider value={refData}>
        {props.children}
      </ScheduleReferenceDataContext.Provider>;
}
